export let EModel;
(function (EModel) {
  EModel["None"] = "none";
  EModel["All"] = "all";
  EModel["ActionQueueItem"] = "actionQueueItem";
  EModel["Activity"] = "activity";
  EModel["ApiClient"] = "apiClient";
  EModel["Appointment"] = "appointment";
  EModel["AppointmentType"] = "appointmentType";
  EModel["AssistantAction"] = "assistantAction";
  EModel["AssistantInstance"] = "assistantInstance";
  EModel["Assistant"] = "assistant";
  EModel["Availability"] = "availability";
  EModel["BillingCopay"] = "billingCopay";
  EModel["BillingTransaction"] = "billingTransaction";
  EModel["Broadcast"] = "broadcast";
  EModel["BroadcastStream"] = "broadcastStream";
  EModel["BroadcastTarget"] = "broadcastTarget";
  EModel["CampaignStream"] = "campaignStream";
  EModel["CampaignTarget"] = "campaignTarget";
  EModel["Campaign"] = "campaign";
  EModel["CcdaCodeSystem"] = "ccdaCodeSystem";
  EModel["CcdaValueSetData"] = "ccdaValueSetData";
  EModel["CcdaValueSet"] = "ccdaValueSet";
  EModel["ChatActivityReason"] = "chatActivityReason";
  EModel["ChatActivity"] = "chatActivity";
  EModel["ChatAudit"] = "chatAudit";
  EModel["ChecklistTemplate"] = "checklistTemplate";
  EModel["Checklist"] = "checklist";
  EModel["ConditionsSet"] = "conditionsSet";
  EModel["CustomWebStyle"] = "customWebStyle";
  EModel["Diagnosis"] = "diagnosis";
  EModel["Estimate"] = "estimate";
  EModel["Facility"] = "facility";
  EModel["FaxDocument"] = "faxDocument";
  EModel["FaxDocumentCategory"] = "faxDocumentCategory";
  EModel["FaxDocumentActionInstance"] = "faxDocumentActionInstance";
  EModel["FaxDocumentWorkflow"] = "faxDocumentWorkflow";
  EModel["FeedbackResponse"] = "feedbackResponse";
  EModel["FileMapping"] = "fileMapping";
  EModel["FileUpload"] = "fileUpload";
  EModel["Followup"] = "followup";
  EModel["FollowupWorkflow"] = "followupWorkflow";
  EModel["FollowupWorkflowGallery"] = "followupWorkflowGallery";
  EModel["FollowupWorkflowInstance"] = "followupWorkflowInstance";
  EModel["Group"] = "group";
  EModel["Guest"] = "guest";
  EModel["Hl7message"] = "hl7message";
  EModel["InboundMessageRequest"] = "inboundMessageRequest";
  EModel["InsuranceEligibility"] = "insuranceEligibility";
  EModel["InsurancePayor"] = "insurancePayor";
  EModel["InsuranceVerificationScheduler"] = "insuranceVerificationScheduler";
  EModel["InsuranceVerification"] = "insuranceVerification";
  EModel["Insurance"] = "insurance";
  EModel["IntegratorClient"] = "integratorClient";
  EModel["Integrator"] = "integrator";
  EModel["Intent"] = "intent";
  EModel["LargeLanguageModelPrompt"] = "largeLanguageModelPrompt";
  EModel["LargeLanguageModelRequest"] = "largeLanguageModelRequest";
  EModel["Login"] = "login";
  EModel["LumaBotFlow"] = "lumaBotFlow";
  EModel["LumaBotFlowTemplate"] = "lumaBotFlowTemplate";
  EModel["Message"] = "message";
  EModel["MessageFailure"] = "messageFailure";
  EModel["MessageRegistration"] = "messageRegistration";
  EModel["MessageRequest"] = "messageRequest";
  EModel["MessageTemplate"] = "messageTemplate";
  EModel["MessageTemplatePartial"] = "messageTemplatePartial";
  EModel["NlpIntent"] = "nlpIntent";
  EModel["NlpIntentEntity"] = "nlpIntentEntity";
  EModel["Offer"] = "offer";
  EModel["Organization"] = "organization";
  EModel["OutboundNumber"] = "outboundNumber";
  EModel["OutboundReferral"] = "outboundReferral";
  EModel["Patient"] = "patient";
  EModel["PatientCreditCard"] = "patientCreditCard";
  EModel["PatientForm"] = "patientForm";
  EModel["PatientFormTemplate"] = "patientFormTemplate";
  EModel["PatientMessageTemplate"] = "patientMessageTemplate";
  EModel["PaymentAudit"] = "paymentAudit";
  EModel["Procedure"] = "procedure";
  EModel["Provider"] = "provider";
  EModel["QueueManagerInstance"] = "queuemanagerinstance";
  EModel["QueueManagerTemplate"] = "queuemanagertemplate";
  EModel["Recall"] = "recall";
  EModel["Referral"] = "referral";
  EModel["Reminder"] = "reminder";
  EModel["Schedule"] = "schedule";
  EModel["Setting"] = "setting";
  EModel["Specialty"] = "specialty";
  EModel["Sync"] = "sync";
  EModel["Telehealth"] = "telehealth";
  EModel["Upload"] = "upload";
  EModel["User"] = "user";
  EModel["Utterance"] = "utterance";
  EModel["WaitingRoomPatient"] = "waitingRoomPatient";
  EModel["Waitlist"] = "waitlist";
  EModel["WaitingRoom"] = "waitingRoom";
  EModel["Page"] = "page";
})(EModel || (EModel = {}));
export let EModelFilterComparision;
(function (EModelFilterComparision) {
  EModelFilterComparision["Eq"] = "eq";
  EModelFilterComparision["Gt"] = "gt";
  EModelFilterComparision["Gte"] = "gte";
  EModelFilterComparision["Lt"] = "lt";
  EModelFilterComparision["Lte"] = "lte";
  EModelFilterComparision["Ne"] = "ne";
  EModelFilterComparision["RegEx"] = "regex";
  EModelFilterComparision["Js"] = "js";
  EModelFilterComparision["Cron"] = "cron";
  EModelFilterComparision["IsDirty"] = "is-dirty";
})(EModelFilterComparision || (EModelFilterComparision = {}));